"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NewCactusItemModal;
var _react = _interopRequireWildcard(require("react"));
var _newcactusMenuUtils = require("../../service/newcactusMenuUtils");
var _newcactusApi = require("../../service/newcactusApi");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function NewCactusItemModal({
  item,
  currency = 'RWF',
  labels = {},
  onConfirm,
  onClose
}) {
  const [selectedOptionIds, setSelectedOptionIds] = (0, _react.useState)([]);
  const [removedIds, setRemovedIds] = (0, _react.useState)([]);
  const [notes, setNotes] = (0, _react.useState)('');
  const [error, setError] = (0, _react.useState)(null);
  const unitPrice = (0, _react.useMemo)(() => (0, _newcactusMenuUtils.calculateUnitPrice)(item, selectedOptionIds), [item, selectedOptionIds]);
  const toggleOption = (0, _react.useCallback)((group, optionId) => {
    const id = Number(optionId);
    setSelectedOptionIds(prev => {
      const groupIds = (group.options ?? []).map(o => Number(o.id));
      const withoutGroup = prev.filter(oid => !groupIds.includes(oid));
      if (group.selection === 'single') {
        return prev.includes(id) ? withoutGroup : [...withoutGroup, id];
      }
      return prev.includes(id) ? prev.filter(oid => oid !== id) : [...prev, id];
    });
    setError(null);
  }, []);
  const toggleRemoved = (0, _react.useCallback)(ingredientId => {
    const id = Number(ingredientId);
    setRemovedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }, []);
  const handleConfirm = () => {
    const validationError = (0, _newcactusMenuUtils.validateOptionSelection)(item, selectedOptionIds);
    if (validationError) {
      setError(validationError);
      return;
    }
    onConfirm({
      menuItemId: item.id,
      productName: item.name,
      basePrice: Number(item.price) || 0,
      unitPrice,
      optionIds: [...selectedOptionIds],
      removedIngredientIds: [...removedIds],
      optionLabels: (0, _newcactusMenuUtils.getSelectedOptionLabels)(item, selectedOptionIds),
      removedLabels: (0, _newcactusMenuUtils.getRemovedLabels)(item, removedIds),
      notes: notes.trim(),
      categoryName: item.categoryName,
      subsectionName: item.subsectionName
    });
  };
  if (!item) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "nc-item-modal-overlay",
    onClick: onClose,
    role: "presentation",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "nc-item-modal",
      role: "dialog",
      "aria-labelledby": "nc-item-modal-title",
      onClick: e => e.stopPropagation(),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
        className: "nc-item-modal__header",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          id: "nc-item-modal-title",
          className: "nc-item-modal__title",
          children: item.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          className: "nc-item-modal__close",
          onClick: onClose,
          "aria-label": "Fermer",
          children: "\xD7"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "nc-item-modal__body",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "nc-item-modal__price",
          children: (0, _newcactusApi.formatCurrency)(unitPrice, currency)
        }), (item.option_groups ?? []).map(group => /*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", {
          className: "nc-item-modal__group",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("legend", {
            className: "nc-item-modal__group-title",
            children: [group.name, group.required && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "nc-item-modal__required",
              children: " *"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "nc-item-modal__options",
            children: (group.options ?? []).map(opt => {
              const checked = selectedOptionIds.includes(Number(opt.id));
              const inputType = group.selection === 'single' ? 'radio' : 'checkbox';
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
                className: "nc-item-modal__option",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                  type: inputType,
                  name: `nc-group-${group.id}`,
                  checked: checked,
                  onChange: () => toggleOption(group, opt.id)
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  children: [opt.label, Number(opt.price) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                    className: "nc-item-modal__option-price",
                    children: [' ', "+", (0, _newcactusApi.formatCurrency)(Number(opt.price), currency)]
                  })]
                })]
              }, opt.id);
            })
          })]
        }, group.id)), (item.removable ?? []).length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", {
          className: "nc-item-modal__group",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("legend", {
            className: "nc-item-modal__group-title",
            children: "Sans\u2026"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "nc-item-modal__options",
            children: item.removable.map(ing => /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
              className: "nc-item-modal__option",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                checked: removedIds.includes(Number(ing.id)),
                onChange: () => toggleRemoved(ing.id)
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                children: ["Sans ", ing.name]
              })]
            }, ing.id))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "nc-item-modal__notes",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
            htmlFor: "nc-notes",
            children: "Note cuisine (optionnel)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            id: "nc-notes",
            type: "text",
            className: "nc-item-modal__notes-input",
            placeholder: "Ex. bien cuite",
            value: notes,
            onChange: e => setNotes(e.target.value)
          })]
        }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "nc-item-modal__error",
          role: "alert",
          children: error
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("footer", {
        className: "nc-item-modal__footer",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          className: "nc-item-modal__cancel",
          onClick: onClose,
          children: "Annuler"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
          type: "button",
          className: "nc-item-modal__confirm",
          onClick: handleConfirm,
          children: [labels.add_to_cart_label || 'Ajouter', " \xB7 ", (0, _newcactusApi.formatCurrency)(unitPrice, currency)]
        })]
      })]
    })
  });
}